import React, {useRef, useState} from 'react';
import {CustomWrapper, SuffixWrapper} from "./styles";
import { DatePicker, DatePickerProps, Drawer, Popover} from "antd";
import type {Moment} from "moment/moment";
import { ReactComponent as CalendarIcon } from '../../../assets/images/calendar-grey.svg';
import {Label} from "../StyledInput/styles";
import FlightDatePicker from '../../FlightSearch/FlightDatePicker/FlightDatePicker';
import { DateRange } from 'react-day-picker';
import { CalendarMinimalistic } from '@solar-icons/react';
import useIsMobile from '../../../hooks/useIsMobile';

type Props = {
     onChange?: (dateString: Moment | null) => void;
    label: string;
    icon?: React.ReactNode;
    selectedRange?: DateRange;
    setSelectedRange: (range: DateRange | undefined) => void;
    returnValue?: any;

} & DatePickerProps

const toDate = (input: any): Date | undefined => {
  if (!input) return undefined;

  const raw = input?.from ?? input?.value ?? input;

  if (!raw) return undefined;

  // Date object — return directly
  if (raw instanceof Date) return Number.isNaN(raw.getTime()) ? undefined : raw;

  // Reject other non-string objects
  if (typeof raw === "object") return undefined;

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

const CustomDatePicker = ({
    onChange,
    disabledDate,
    value,
    returnValue,
    label,
    selectedRange,
    setSelectedRange,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const popoverContainerRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const { isMobile } = useIsMobile();
    const modalContainerRef = useRef(null);

    const formatDate = (date?: Date) => {
        if (!date || Number.isNaN(date.getTime())) return "";
        return date.toLocaleDateString();
    };
    
    const resolvedRange: DateRange = {
        from: selectedRange?.from ?? toDate(value),
        to: selectedRange?.to ?? toDate(value?.to) ?? toDate(returnValue),
    };

    const dateLabel = resolvedRange.from
    ? `${formatDate(resolvedRange.from)}${
        resolvedRange.to ? ` - ${formatDate(resolvedRange.to)}` : ""
        }`
    : "";

    const renderPrefix = () => {
        return <SuffixWrapper onClick={() => setIsOpen(true)}>
           <CalendarMinimalistic weight='Bold' />
            <Label>
                Date: {dateLabel}
            </Label>
        </SuffixWrapper>
    }

    const desktopContent = (
        <FlightDatePicker
              initialRange={resolvedRange}
              onApply={(nextRange) => setSelectedRange(nextRange)}
            onClose={() => setIsOpen(false)}
            minDate={new Date()}
        />
    );

    return (
        isMobile ? (
            <>
                <CustomWrapper
                    ref={popoverContainerRef}
                    onClick={() => setVisible(true)}
                    className='mobile-date-custom-popover'
                    style={{marginBottom: '10px'}}
                >
                    {renderPrefix()}
                </CustomWrapper>
                <Drawer
                placement="bottom"
                open={visible}
                onClose={() => setVisible(false)}
                footer={null}
                height="100%"
                title=""
                    getContainer={modalContainerRef.current}
                style={{padding: 0}}
                >
                <FlightDatePicker
                    initialRange={resolvedRange}
                    onApply={(nextRange) => setSelectedRange(nextRange)}
                        onClose={() => { setIsOpen(false);  setVisible(false); }}
                    minDate={new Date()}
                    />
                    
                </Drawer>
            </>
        ): (
        
            <Popover
                placement="bottomLeft"
                content={desktopContent}
                    overlayInnerStyle={{ width: 1030 }}
                open={isOpen}
                trigger="click"
                getPopupContainer={() => popoverContainerRef.current as HTMLElement}
                onOpenChange={(open) => setIsOpen(open)}
                overlayClassName="date-custom-popover"
        >
            <CustomWrapper
            ref={popoverContainerRef}
            >
                {renderPrefix()}
            </CustomWrapper>
        </Popover >
        )
        
    );
};

export default CustomDatePicker;
